import React from 'react';
import UfoIcon from './UfoIcon';
import { Position, EmojiStatus } from '../../utils/types';

export interface EmojiComponentProps {
  id: string;
  position: Position;
  status: EmojiStatus;
  emoji: string;
  ufoType: 'basic' | 'armored' | 'stealth';
  onTap: (e: React.TouchEvent | React.MouseEvent) => void;
}

const EmojiComponent = ({ 
  id, 
  position, 
  status, 
  emoji, 
  ufoType, 
  onTap 
}: EmojiComponentProps) => {
  const { x, y, rotation } = position;
  
  // Generate unique animation offset for each UFO to avoid synchronized movements
  const animationOffset = parseInt(id.replace(/\D/g, '')) || 0;
  
  return (
    <div
      data-emoji-id={id}
      style={{
        position: 'absolute',
        left: x,
        top: y,
        transform: `translate(-50%, -50%)`,
        cursor: 'pointer',
        opacity: status === 'captured' ? 1 : 0.5,
        transition: 'opacity 0.3s ease',
        pointerEvents: status === 'captured' ? 'auto' : 'none',
        zIndex: 10,
        filter: status === 'rescued' ? 'brightness(1.5) drop-shadow(0 0 10px #4CAF50)' : 'none'
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
        onTap(e);
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        onTap(e);
      }}
      onClick={(e) => {
        e.stopPropagation();
        onTap(e);
      }}
    >
      <UfoIcon 
        // rotation={rotation + 90} 
        emoji={emoji}
        ufoType={ufoType}
        isRescueAnimation={status === 'rescued'}
        animationOffset={animationOffset}
      />
    </div>
  );
};

export default EmojiComponent; 